<template>
  <div id="tf-home" class="text-center">
    <div class="overlay">
      <div class="content">
        <h1>
          {{ $t("home.welcome") }}
          <strong class="color"
            ><span>Bodor+ 3.0 </span>
            <p v-if="props.screenSize < 769">{{ $t("home.welcome2") }}</p>
            <span v-else>{{ $t("home.welcome2") }}</span></strong
          >
        </h1>
        <p class="lead" style="line-height: 20px">
          {{ $t("home.intro1") }} <strong>{{ $t("home.year") }}</strong>
          {{ $t("home.and") }} <strong>{{ $t("home.people") }}</strong
          >{{ $t("home.intro2") }}
        </p>
        <a href="#tf-bodorplus" class="fa fa-angle-down page-scroll"></a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
const props = defineProps({
  screenSize: {
    type: Number,
    default: 1920,
  },
});
</script>

<style scoped>
#tf-home {
  background: url("@/assets/img/home.jpg");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  color: #cfcfcf;
}
p {
  line-height: 80px;
}
@media (max-width: 500px) {
  .lead {
    font-size: 14px;
  }
}
</style>
